<template>
    <div>
        <div class="header_unit header_bg_blue">
            <div class="header_box">
                <div class="menu_left">
                    <a href="#" role="button" class="router-link-active" @click.prevent.stop="openAlertModal()" >キャンセル</a>
                </div>
                <div class="menu_center">
                    <p class="menu_center_tex_s">{{upperButtonName}}</p>
                    <p class="menu_center_tex_l">{{lowerButtonName}}</p>
                </div>
                <div class="menu_right">
                    <a href="#" role="button" class="router-link-active" @click.prevent.stop="openAlertModal()"><i class="far fa-question-circle"></i> マニュアル</a>
                </div>
            </div>
        </div>

        <div class="main_unit">
            <div class="top_unit">
                <div class="top_right_box_mgt">プレビュー表示 </div>
            </div>

            <pulse-loader class="w-100 text-center" :loading="isInitLoading"></pulse-loader>
            <div v-show="!isInitLoading">
                <div class="check_tyori_tbl_unit tbl_bg_blue mgt_15" style="max-height: 700px;display: flex;">

                    <div>
                        <div class="all_ok_unit" >
                            <div class="all_ok_head" v-bind:style="headerStyle">すべて〇</div>
                            <div v-for="(Item, allOkIndex) in filterItems" :key="Item.indexLng">
                                <div :id=allOkIndex class="all_ok_area" v-bind:style="boxStyle">
                                    <a href="#" role="button" class="all_ok_box" v-if="Item.allCheckFlg==='0'" @click.prevent.stop="clickAllCheck(Item.indexLng)"></a>
                                    <a href="#" role="button" class="all_ok_box" v-if="Item.allCheckFlg==='1'" @click.prevent.stop="clickAllCheck(Item.indexLng)">
                                        <p class="icn_blue_ss"><i class="fas fa-check"></i></p>
                                    </a>
                                    <a href="#" role="button" class="all_ok_box_disabled" v-if="Item.allCheckFlg==='2'"></a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div>
                      <table class="check_tyori_tbl_unit_table_contents" >
                          <tbody v-if="rowspan == 1" ref="tbody" class="cooking_setting_sticky_top z_3">
                          <tr >
                              <th class="wd240 checkSetting_text_align cooking_check_sticky z_3" style="max-width: 240px;white-space: normal;left:0px">調理名</th>
                              <th class="wd120 cooking_check_sticky z_3" colspan="2" style="text-align: center;left:240px">加熱後温度</th>
                              <th v-if="cookingCheckButtonNo == 5" class="wd120 cooking_check_sticky z_3" colspan="2" style="text-align: center;left:360px">再加熱後温度</th>
                              <th class="wd90" >履歴</th>
                              <th v-if="isExitsGroup" class="wd240 checkSetting_text_align" >グループ</th>
                              <th rowspan="2" class="wd90 tbl_tex_center text_white_space" v-for="HeaderList in headerFilter1" :key="'hdInfo_' +HeaderList.cookingCheckHeaderNo" :id="HeaderList.cookingCheckHeaderNo">
                                {{HeaderList.lowerButtonName}}
                              </th>

                              <th rowspan="2"  class="checkSetting_text_align">改善措置／コメント
                                <a role="button" @click.prevent.stop="openModel(cookingCheckMenuList.informationFilePath,modal_type.info)"><i class="fas fa-info-circle info_icn_red"></i></a>
                              </th>

                          </tr>
                          <tr >
                              <th class="wd240 checkSetting_text_align cooking_check_sticky z_3" style="max-width: 240px;white-space: normal;left:0px">
                                <input class="modal_text_field" type="text" v-model="searchWord" placeholder="調理名検索">
                              </th>
                              <th class="text_white_space cooking_check_sticky z_3 wd60" style="text-align: center;left:240px">下限</th>
                              <th class="text_white_space cooking_check_sticky z_3 wd60" style="text-align: center;left:300px">上限</th>
                              <th v-if="cookingCheckButtonNo == 5" class="text_white_space cooking_check_sticky z_3 wd60" style="text-align: center;left:360px">下限</th>
                              <th v-if="cookingCheckButtonNo == 5" class="text_white_space cooking_check_sticky z_3 wd60" style="text-align: center;left:420px">上限</th>
                              <th class="border_top_none alertList_text_align">
                                <select id="historyFilter"  v-model="selectFilterFlg">
                                  <option v-for="historyFlg in historyFilter" :key="historyFlg['id']" :value="historyFlg['id']">{{historyFlg['name']}}</option>
                                </select>
                              </th>
                              <th v-if="isExitsGroup" class="border_top_none alertList_text_align">
                                <select id="selectGroup"  v-model="selectGroupWord">
                                  <option value="">全て</option>
                                  <option v-for="group in cookingNameGroup" :key="group['id']" :value="group['groupName']">{{group['groupName']}}</option>
                                </select>
                              </th>
                          </tr>

                          </tbody>
                          <tbody v-if="rowspan == 2" ref="tbody" class="cooking_setting_sticky_top z_3">
                          <tr >
                              <th class="wd240 checkSetting_text_align cooking_check_sticky z_3" style="max-width: 240px;white-space: normal;left:0px">調理名</th>
                              <th class="wd120_fix_min cooking_check_sticky z_3" colspan="2" style="text-align: center;left:240px">加熱後温度</th>
                              <th v-if="cookingCheckButtonNo == 5" class="wd120_fix_min cooking_check_sticky z_3" colspan="2" style="text-align: center;left:360px">再加熱後温度</th>
                              <th class="wd90" >履歴</th>
                              <th v-if="isExitsGroup" class="wd240 checkSetting_text_align" >グループ</th>
                              <th class="tbl_tex_center text_white_space wd90" v-if="cookingCheckMenuList.cookingHeaderList[0].inputType == 6 && cookingCheckMenuList.cookingHeaderList[0].displayFlg == 1"
                                  rowspan="2">{{cookingCheckMenuList.cookingHeaderList[0].lowerButtonName}} </th>
                              <th class="tbl_tex_center text_white_space" v-if="hedderUpname1 !== '' && hedderUpname1 !== null" :colspan="hedderList1">{{hedderUpname1}}</th>
                              <th class="tbl_tex_center text_white_space" v-if="hedderUpname2 !== '' && hedderUpname2 !== null" :colspan="hedderList2">{{hedderUpname2}}</th>
                              <th class="tbl_tex_center text_white_space" v-if="hedderUpname3 !== '' && hedderUpname3 !== null" :colspan="hedderList3">{{hedderUpname3}}</th>
                              <th class="tbl_tex_center text_white_space" v-if="hedderUpname4 !== '' && hedderUpname4 !== null" :colspan="hedderList4">{{hedderUpname4}}</th>
                              <th rowspan="2" class="wd90 tbl_tex_center text_white_space" v-for="HeaderList in headerFilter3" :key="'hdInfo_' +HeaderList.cookingCheckHeaderNo" :id="HeaderList.cookingCheckHeaderNo">
                                {{HeaderList.lowerButtonName}}
                              </th>
                              <th rowspan="2"  class="checkSetting_text_align">改善措置／コメント
                                <a role="button" @click.prevent.stop="openModel(cookingCheckMenuList.informationFilePath,modal_type.info)"><i class="fas fa-info-circle info_icn_red"></i></a>
                              </th>
                          </tr>

                          <tr >
                            <th class="wd240 checkSetting_text_align cooking_check_sticky z_3" style="max-width: 240px;white-space: normal;left:0px">
                              <input class="modal_text_field" type="text" v-model="searchWord" placeholder="調理名検索">
                            </th>
                            <th class="text_white_space cooking_check_sticky z_3 wd60" style="text-align: center;left:240px">下限</th>
                            <th class="text_white_space cooking_check_sticky z_3 wd60" style="text-align: center;left:300px">上限</th>
                            <th v-if="cookingCheckButtonNo == 5" class="text_white_space cooking_check_sticky z_3 wd60" style="text-align: center;left:360px">下限</th>
                            <th v-if="cookingCheckButtonNo == 5" class="text_white_space cooking_check_sticky z_3 wd60" style="text-align: center;left:420px">上限</th>
                            <th class="border_top_none alertList_text_align">
                              <select id="historyFilter"  v-model="selectFilterFlg">
                                <option v-for="historyFlg in historyFilter" :key="historyFlg['id']" :value="historyFlg['id']">{{historyFlg['name']}}</option>
                              </select>
                            </th>
                            <th v-if="isExitsGroup" class="border_top_none alertList_text_align">
                              <select id="selectGroup"  v-model="selectGroupWord">
                                <option value="">全て</option>
                                <option v-for="group in cookingNameGroup" :key="group['id']" :value="group['groupName']">{{group['groupName']}}</option>
                              </select>
                            </th>
                            <th class="wd90 tbl_tex_center text_white_space" v-for="HeaderList in headerFilter1" :key="'hdInfo_' +HeaderList.cookingCheckHeaderNo" :id="HeaderList.cookingCheckHeaderNo">
                              {{HeaderList.lowerButtonName}}
                            </th>
                          </tr>
                          </tbody>
                          <tbody id="tdHeight">
                          <tr  v-for="(Item,indexCount) in filterItems" :key="Item.indexLng">
                              <td class="cooking_background-color_def cooking_check_sticky" style="max-width: 240px;white-space: normal;left:0;">
                                  <label style="font-size: 15px;color: #305d76;width:100%;text-align: left;padding: 8px;">{{Item["cookingName"]}}</label>
                              </td>
                              <td class="cooking_background-color_def cooking_check_sticky wd60" style="left:240px"><label style="font-size: 15px;color: #305d76;width:100%;text-align: left;padding: 8px;">{{Item["heatedLowerTemperature"]}}</label></td>
                              <td class="cooking_background-color_def cooking_check_sticky wd60" style="left:300px"><label style="font-size: 15px;color: #305d76;width:100%;text-align: left;padding: 8px;">{{Item["heatedUpperTemperature"]}}</label></td>
                              <td v-if="cookingCheckButtonNo == 5" class="cooking_background-color_def cooking_check_sticky wd60" style="left:360px"><label style="font-size: 15px;color: #305d76;width:100%;text-align: left;padding: 8px;">{{Item["reHeatedLowerTemperature"]}}</label></td>
                              <td v-if="cookingCheckButtonNo == 5" class="cooking_background-color_def cooking_check_sticky wd60" style="left:420px"><label style="font-size: 15px;color: #305d76;width:100%;text-align: left;padding: 8px;">{{Item["reHeatedUpperTemperature"]}}</label></td>

                              <!--履歴-->
                              <td class="cooking_background-color_def">
                              </td>
                              <td v-if="isExitsGroup" class="cooking_background-color_def">
                                <label style="font-size: 15px;color: #305d76;width:100%;text-align: left;padding: 8px;">{{Item["groupName"]}}</label>
                              </td>


                              <td v-for="(List,index) in headerFilter2" :key="List.cookingCheckHeaderNo"  :id="indexCount" :class="chengeClore(Item.histryData,index)">

                                  <label class="disabled" v-if="List.inputType == 6 && Item.todayInputFlg == '' &&
                                       Item['htsi_' +List.cookingCheckHeaderId] == ''"></label>
                                  <a href="#" role="button" v-if="List.inputType == 6 && Item.todayInputFlg == '' && Item['htsi_' +List.cookingCheckHeaderId] == '1'"  @click.prevent.stop="todayCheckInput(Item.indexLng,List.cookingCheckHeaderId)">
                                      <p class="icn_white_td"><i class="far fa-check"></i></p></a>
                                  <a href="#" role="button" v-if="List.inputType == 6 && Item.todayInputFlg == '1' && Item['htsi_' +List.cookingCheckHeaderId] == '1'"  @click.prevent.stop="todayCheckInput(Item.indexLng,List.cookingCheckHeaderId)" >
                                      <p class="icn_blue_s_td" ><i class="fas fa-check"></i></p></a>

                                  <label class="disabled " v-if="List.inputType == 4 &&  (Item['htsi_' +List.cookingCheckHeaderId] == '' || (Item.todayInputFlg == '1'
                                         && (List.cookingCheckHeaderNo == 2 || List.cookingCheckHeaderNo == 3 || List.cookingCheckHeaderNo == 4 || List.cookingCheckHeaderNo == 5 ||
                                         List.cookingCheckHeaderNo == 6 || List.cookingCheckHeaderNo == 7 )))"></label>
                                  <a href="#" role="button" @click.prevent.stop="clickCheck($event,'hd_' + List.cookingCheckHeaderId,Item.indexLng,List.cookingCheckHeaderId)" :id="'hd_' +List.cookingCheckHeaderId"
                                     v-else-if="List.inputType == 4 && Item['hd_' + List.cookingCheckHeaderId] == '' &&
                                         (Item.todayInputFlg == '' || (List.cookingCheckHeaderNo != 2 || List.cookingCheckHeaderNo != 3 || List.cookingCheckHeaderNo !==4 || List.cookingCheckHeaderNo != 5 ||
                                         List.cookingCheckHeaderNo != 6 || List.cookingCheckHeaderNo != 7))">
                                      <p class="icn_white_td"><i class="far fa-circle"></i></p></a>
                                  <a href="#" role="button" @click.prevent.stop="clickCheck($event,'hd_' + List.cookingCheckHeaderId,Item.indexLng,List.cookingCheckHeaderId)" :id="'hd_' + List.cookingCheckHeaderId"
                                     v-else-if="List.inputType == 4 && Item['hd_' + List.cookingCheckHeaderId] == 1 &&
                                         (Item.todayInputFlg == '' || (List.cookingCheckHeaderNo != 2 || List.cookingCheckHeaderNo != 3 || List.cookingCheckHeaderNo != 4 || List.cookingCheckHeaderNo != 5 ||
                                         List.cookingCheckHeaderNo != 6 || List.cookingCheckHeaderNo != 7))">
                                      <p class="icn_blue_td"><i class="far fa-circle"></i></p></a>
                                  <a href="#" role="button" @click.prevent.stop="clickCheck($event,'hd_' + List.cookingCheckHeaderId ,Item.indexLng,List.cookingCheckHeaderId)" :id="'hd_' + List.cookingCheckHeaderId"
                                     v-else-if="List.inputType == 4 && Item['hd_' + List.cookingCheckHeaderId] == 2 &&
                                         (Item.todayInputFlg == '' || (List.cookingCheckHeaderNo != 2 || List.cookingCheckHeaderNo != 3 || List.cookingCheckHeaderNo != 4 || List.cookingCheckHeaderNo != 5 ||
                                         List.cookingCheckHeaderNo != 6 || List.cookingCheckHeaderNo != 7))">
                                      <p class="icn_red_td"><i class="fas fa-times"></i></p></a>


                                  <label class="disabled" :id="'hd_' + List.cookingCheckHeaderId"
                                         v-if="List.inputType == 5 && (Item['htsi_' +List.cookingCheckHeaderId] == '' || (Item.todayInputFlg == '1'
                                      && (List.cookingCheckHeaderNo == 2 || List.cookingCheckHeaderNo == 3 || List.cookingCheckHeaderNo == 4 || List.cookingCheckHeaderNo == 5 ||
                                      List.cookingCheckHeaderNo == 6 || List.cookingCheckHeaderNo == 7 )))"></label>
                                  <a href="#" role="button" @click.prevent.stop="openAlertModal()" :id="'hd_' + List.cookingCheckHeaderId"
                                     v-else-if="List.inputType == 5 && Item['htsi_' +List.cookingCheckHeaderId] == '1' &&
                                         (Item.todayInputFlg == '' || (List.cookingCheckHeaderNo != 2 || List.cookingCheckHeaderNo != 3 || List.cookingCheckHeaderNo != 4 || List.cookingCheckHeaderNo != 5 ||
                                         List.cookingCheckHeaderNo != 6 || List.cookingCheckHeaderNo != 7))" >選択</a>

                                  <div class="cp_ipselect cp_sl01 wd150" v-if="List.inputType == 2">
                                      <select :disabled="Item['htsi_' +List.cookingCheckHeaderId] == ''">
                                          <option value="" ></option>
                                      </select>
                                  </div>

                                  <label v-if="List.inputType == 1 && (Item['htsi_' +List.cookingCheckHeaderId] == '' || (Item.todayInputFlg == '1'
                                          && (List.cookingCheckHeaderNo == 2 || List.cookingCheckHeaderNo == 3 || List.cookingCheckHeaderNo == 4 || List.cookingCheckHeaderNo == 5 ||
                                          List.cookingCheckHeaderNo == 6 || List.cookingCheckHeaderNo == 7 )))"  :id="'hd_' +Item.indexLng + '' + List.inputType" />
                                  <input type="text" class="textbox_td"  :id="'hd_' +Item.indexLng + '' + List.inputType"
                                         v-if="List.inputType == 1 && Item['htsi_' +List.cookingCheckHeaderId] == '1' &&
                                      (Item.todayInputFlg == '' || (List.cookingCheckHeaderNo != 2 || List.cookingCheckHeaderNo != 3 || List.cookingCheckHeaderNo !==4 || List.cookingCheckHeaderNo != 5 ||
                                      List.cookingCheckHeaderNo != 6 || List.cookingCheckHeaderNo != 7))" maxlength="30" v-model="Item.histryData[index].result_value">


                                  <label v-if="(List.inputType == 3 || List.inputType == 7) && (Item['htsi_' +List.cookingCheckHeaderId] == '' || (Item.todayInputFlg == '1'
                                  && (List.cookingCheckHeaderNo == 2 || List.cookingCheckHeaderNo == 3 || List.cookingCheckHeaderNo == 4 || List.cookingCheckHeaderNo == 5 ||
                                  List.cookingCheckHeaderNo == 6 || List.cookingCheckHeaderNo == 7 )))" />
                                  <vue-timepicker @close="onCloseTimePicker(Item.histryData[index].result_value, indexCount, index)" v-model="Item.histryData[index].result_value" hour-lavel="時" minute-lavel="分" v-if="(List.inputType == 3 || List.inputType == 7) && Item['htsi_' +List.cookingCheckHeaderId] == '1' &&
                                      (Item.todayInputFlg == '' || (List.cookingCheckHeaderNo != 2 || List.cookingCheckHeaderNo != 3 || List.cookingCheckHeaderNo !==4 || List.cookingCheckHeaderNo != 5 ||
                                      List.cookingCheckHeaderNo != 6 || List.cookingCheckHeaderNo != 7))"/>

                              </td>
                              <td class="cooking_background-color_def">
                                      <textarea class="texbox_td" placeholder="コメントを入力" :value="Item.comment" :id="Item['hdte_' + Item.indexLng]" maxlength="200" >
                                      </textarea>
                              </td>
                          </tr>
                          </tbody>
                      </table>
                    </div>
                </div>
                <div class="btn_submit letter_spa">
                    <a href="#" role="button" class="router-link-active" @click.prevent.stop="openAlertModal()">送信</a>
                </div>
            </div>
        </div>
        <div class="overlay_loder" v-show="isLoading">
            <pulse-loader class="w-100 text-center" :loading="isLoading"></pulse-loader>
        </div>

        <AlertDialog :display="showModal.alertDisplay" @close="closeAlertModal"/>
    </div>
</template>

<script>
    import AlertDialog from '@/app/components/common/AlertDialog.vue'
    import VueTimepicker from 'vue2-timepicker'
    import 'vue2-timepicker/dist/VueTimepicker.css'
    import PulseLoader from '@/app/components/PulseLoader.vue'

    export default {
        name: "cookingCheckInputPreview",
        components: {
            AlertDialog,
            VueTimepicker,
            PulseLoader,
        },
        props:{
            subMenuId: {
                type: Number,
                require: true
            },
            reInputFlg: {
                type: Number,
                require: true,
                default: 0,
            }
        },
        data: function () {
            return {
                showModal: {
                    alertDisplay:false
                },
                isLoading: false,
                isInitLoading:true,
                page: 1, //現在のページ番号
                perPage: 10, //1ページ毎の表示件数
                totalPage: 20,
                list:[{indexLng:0,
                    cookingId:"",
                    tyori:"",
                    comment:"",
                    todayInputFlg:"",
                    allCheckFlg:"",
                    cencer:"",
                    historyFlg:"",
                    heatedUpperTemperature:"",
                    heatedLowerTemperature:"",
                    reHeatedUpperTemperature:"",
                    reHeatedLowerTemperature:"",
                    histryData:[{cookingcheckitemid:null,cookingCheckHeaderId:null,cookingCheckHeaderNo:null,dayStatus:null,defStatus:null,result_value:null,input_type:null}]
                }],
                hedderUpname1:"",
                hedderUpname2:"",
                hedderUpname3:"",
                hedderUpname4:"",
                hedderList1:"1",
                hedderList2:"1",
                hedderList3:"1",
                hedderList4:"1",
                rowspan:0,
                cookingColorDisabled:'cooking_background-color_disabled',
                cookingColorNoInput:'cooking_background-color_no-input',
                cookingColorInput:'cooking_background-color_input',
                cookingCheckMenuList: {
                    cookingCheckButtonId: "",
                    cookingCheckPageId: null,
                    manualFilePath: "",
                    informationFilePath: "",
                    cookingHeaderList: [],
                    cookingList: [],
                },
                cookingHeaderList: [
                    {
                        cookingCheckHeaderId: null,
                        cookingCheckHeaderNo: null,
                        upperButtonName: "",
                        lowerButtonName: "",
                        displayFlg: null,
                        inputType: null,
                    }
                ],
                //重要管理項目チェック詳細取得(履歴の表示制御と調理名の入力制御)
                cooking: {
                    cookingId: null,
                    existHistory: '',
                    checkedList: []
                },
                headerStyle: {
                    height: ""
                },
                boxStyle: {
                    height: ""
                },
                searchWord:"",
                selectGroupWord:"",
                cookingNameGroup:[],
                isExitsGroup:false,
                selectFilterFlg:2,
                historyFilter:[
                  {
                    "id":2,
                    "name":"全て"
                  },
                ],
                cookingCheckButtonNo:0,
            }
        },
        updated() {
            this.allOkHeader()
        },
        computed:{
            brandId () {
                return this.$store.getters['brand/id']
            },
            upperButtonName () {
                return this.$store.getters['preview/upperButtonName'];
            },
            lowerButtonName () {
                return this.$store.getters['preview/lowerButtonName'];
            },
            headerItem () {
                return function (id) {
                    return this.$store.getters['preview/headerItem'](id);
                };
            },
            cookingList () {
                return this.$store.getters['preview/cookingList'];
            },
            headerFilter1:function(){
                if(this.rowspan == 2) {
                  return this.cookingCheckMenuList.cookingHeaderList.filter(e => e.inputType !== 6 && e.displayFlg == 1 && (e.upperButtonName !== '' && e.upperButtonName !== null ))
                } else {
                  return this.cookingCheckMenuList.cookingHeaderList.filter(e => e.inputType !== 6 && e.displayFlg == 1 )
                }
            },
            headerFilter2:function(){
                return this.cookingCheckMenuList.cookingHeaderList.filter(function (el) {
                    return el.displayFlg
                },this)
            },
            headerFilter3:function(){
                return this.cookingCheckMenuList.cookingHeaderList.filter(e => e.inputType !== 6 && e.displayFlg == 1 && (e.upperButtonName === '' || e.upperButtonName === null ))
            },
            filterItems() {
                var data = this.list;
                var filterWord = this.searchWord && this.searchWord.toLowerCase();
                if(filterWord){
                  data = data.filter(function (row){
                    return Object.keys(row).some(function (){
                      return String(row["cookingName"]).toLowerCase().includes(filterWord)
                    })
                  })
                }
                // グループフィルター
                if(this.selectGroupWord !== ""){
                  var filterGroupWord = this.selectGroupWord && this.selectGroupWord.toLowerCase();
                  if(filterGroupWord === '未グループ') {
                    data = data.filter(function (row){
                      return row["groupName"] == null;
                    })
                  } else {
                    data = data.filter(function (row){
                      return Object.keys(row).some(function (){
                        return String(row["groupName"]).toLowerCase().indexOf(filterGroupWord) === 0
                      })
                    })
                  }
                }
                return data;
            },

        },
        created: function(){
            this.calc();
        },
        methods: {
            openAlertModal() {
                this.showModal.alertDisplay = true;
            },
            closeAlertModal() {
                this.showModal.alertDisplay = false;
            },
            onPageChange(page) {
                this.page = page;
            },
            async calc(){
                await this.getCookingName();
                await this.getCookingMenu();
                this.isInitLoading = false;

                //ヘッダーの行列を設定する
                for( var T=0 ; T < this.cookingCheckMenuList.cookingHeaderList.length ; T++){

                    //列セルの結合数のチェック
                    if(this.cookingCheckMenuList.cookingHeaderList[T].upperButtonName !== "" &&
                        this.cookingCheckMenuList.cookingHeaderList[T].upperButtonName !== null){
                        this.rowspan = 2;
                        break;
                    }else{
                        this.rowspan = 1;
                    }
                }

                //カラムの結合処理
                var colspanInt = 0;
                var groupId = 1;
                var serchStr= '';
                for( var L=0 ; L < this.cookingCheckMenuList.cookingHeaderList.length ; L++){

                    var upperHdName = this.cookingCheckMenuList.cookingHeaderList[L].upperButtonName;
                    if(serchStr !== upperHdName && this.cookingCheckMenuList.cookingHeaderList[L].displayFlg == 1){
                        var dddd = this.cookingCheckMenuList.cookingHeaderList.filter(e => e.upperButtonName == upperHdName && e.displayFlg == 1 )
                        colspanInt = dddd.length;
                        switch (groupId) {
                            case 1:
                                this.hedderList1 = String(colspanInt);
                                this.hedderUpname1 = upperHdName;
                                serchStr = upperHdName;
                                groupId = groupId +1 ;
                                break;
                            case 2:
                                this.hedderList2 = String(colspanInt);
                                this.hedderUpname2 = upperHdName;
                                serchStr = upperHdName;
                                groupId = groupId +1 ;
                                break;
                            case 3:
                                this.hedderList3 = String(colspanInt);
                                this.hedderUpname3 = upperHdName;
                                serchStr = upperHdName;
                                groupId = groupId +1 ;
                                break;
                            case 4:
                                this.hedderList4 = String(colspanInt);
                                this.hedderUpname4 = upperHdName;
                                serchStr = upperHdName;
                                groupId = groupId +1 ;
                                break;
                        }
                    }
                }

                //画面の初期処理に呼び出す
                let itemList = [];
                //ヘッダーのID設定を追加
                for(var k = 0 ; k < this.cookingCheckMenuList.cookingList.length ; k++){

                    var indexList = new Object();
                    var inpuotApiData = [];
                    for( var i=0 ; i < this.cookingCheckMenuList.cookingHeaderList.length ; i++){
                        var inpuotApiDataObj = new Object();
                        if(this.cookingCheckMenuList.cookingHeaderList[i].displayFlg){

                            inpuotApiDataObj['cookingCheckHeaderId']= this.cookingCheckMenuList.cookingHeaderList[i].cookingCheckHeaderId;
                            inpuotApiDataObj['cookingCheckHeaderNo']= this.cookingCheckMenuList.cookingHeaderList[i].cookingCheckHeaderNo;
                            inpuotApiDataObj['status']= null;
                            inpuotApiDataObj['result_value']=null;
                            inpuotApiDataObj['defStatus']=1;
                            inpuotApiDataObj['dayStatus']=null;
                            inpuotApiDataObj["cookingcheckitemid"] = null;
                            inpuotApiDataObj['input_type']= this.cookingCheckMenuList.cookingHeaderList[i].inputType;

                            var indexHdId = "hd_" + this.cookingCheckMenuList.cookingHeaderList[i].cookingCheckHeaderId;
                            var indexHdId2 = "htsi_" + this.cookingCheckMenuList.cookingHeaderList[i].cookingCheckHeaderId;
                            indexList[indexHdId]  = "";
                            indexList[indexHdId2]  = 1;

                            inpuotApiData.push(inpuotApiDataObj);
                        }
                    }
                    indexList["cookingId"] = this.cookingCheckMenuList.cookingList[k].cookingId;
                    indexList["cookingNameNo"] = null;
                    indexList["tyori"] = "";
                    indexList["cookingName"] = this.cookingCheckMenuList.cookingList[k].cookingName;
                    indexList["cookingNo"] = "";
                    indexList["comment"] = "";
                    indexList["todayInputFlg"] = "";
                    indexList["allCheckFlg"] = this.updateAllCheckFlg(indexList);
                    indexList["cencer"] = "";
                    indexList["historyFlg"] = 0;
                    indexList["indexLng"] = k;
                    indexList["histryData"] = inpuotApiData;
                    indexList["groupName"] = this.cookingCheckMenuList.cookingList[k].groupName;
                    indexList["heatedUpperTemperature"] = this.cookingCheckMenuList.cookingList[k].heatedUpperTemperature;
                    indexList["heatedLowerTemperature"] = this.cookingCheckMenuList.cookingList[k].heatedLowerTemperature;
                    indexList["reHeatedUpperTemperature"] = this.cookingCheckMenuList.cookingList[k].reHeatedUpperTemperature;
                    indexList["reHeatedLowerTemperature"] = this.cookingCheckMenuList.cookingList[k].reHeatedLowerTemperature;
                    itemList.push(indexList);
                }

                this.list = itemList;
            },
            async getCookingName() {
                // 調理名一覧取得API
                await this.$axios
                    .get(this.$apiEndpoint + 'manage/brand/' + this.brandId + '/cooking_check/' + this.subMenuId + '/cooing_name')
                    .then(response => {
                        this.cookingCheckMenuList.cookingList = response.data.cookingCheckButton.cookingNameList;
                        this.cookingCheckButtonNo = response.data.cookingCheckButton.cookingCheckButtonNo;

                        if(this.cookingList){
                            let i = 1;
                            this.cookingCheckMenuList.cookingList = this.cookingList.map(cooking => {
                                if(cooking.groupName !== "" && cooking.groupName != null && !this.cookingNameGroup.some( group => group.groupName === cooking.groupName)) {
                                  var group = new Object();
                                  group['groupName'] = cooking.groupName;
                                  this.cookingNameGroup.push(group);
                                }
                                cooking.cookingId = i;
                                i++;
                                return cooking;
                            });
                        } else {
                          this.cookingCheckMenuList.cookingList.forEach(cooking => {
                            if(cooking.groupName !== "" && cooking.groupName != null && !this.cookingNameGroup.some( group => group.groupName === cooking.groupName)) {
                              var group = new Object();
                              group['groupName'] = cooking.groupName;
                              this.cookingNameGroup.push(group);
                            }
                          });
                        }
                        if(this.cookingNameGroup.length > 0){
                          this.isExitsGroup = true;
                          if(!this.cookingNameGroup.some( group => group.groupName === '未グループ')){
                            var noGroup = new Object();
                            noGroup['groupName'] = '未グループ';
                            this.cookingNameGroup.unshift(noGroup);
                          }
                        }

                    })
                    .catch((err) => {
                        let error = {
                            button: {
                                path: {name: ''}
                            },
                            canBack: false
                        };
                        if (err.customError) {
                            error = Object.assign(error, err.customError)
                        }
                        this.$store.dispatch('error/setError', error).then(this.$router.push({name: 'error'}))
                    });
            },
            async getCookingMenu() {
                // 重要管理項目メニュー設定取得API
                await this.$axios
                    .get(this.$apiEndpoint + 'manage/brand/' + this.brandId + '/cooking_check/' + this.subMenuId, { params: { datetime: this.dateFormat()}})
                    .then(response => {
                        this.cookingCheckMenuList.cookingCheckButtonId = String(response.data.foodGroupSetting.cookingCheckButtonId);
                        this.cookingCheckMenuList.cookingCheckPageId = response.data.foodGroupSetting.cookingCheckPageId;
                        this.cookingCheckMenuList.cookingHeaderList = response.data.foodGroupSetting.headerItemList;

                        this.cookingCheckMenuList.cookingHeaderList.map((header) => {
                            let headerItem = this.headerItem(header.cookingCheckHeaderId);
                            if(!headerItem) {
                                return header;
                            }
                            header.displayFlg = headerItem.displayFlg;
                            header.upperButtonName = headerItem.upperButtonName;
                            header.lowerButtonName = headerItem.lowerButtonName;
                            return header;
                        });
                    })
                    .catch((err) => {
                        let error = {
                            button: {
                                path: {name: ''}
                            },
                            canBack: false
                        };
                        if (err.customError) {
                            error = Object.assign(error, err.customError)
                        }
                        this.$store.dispatch('error/setError', error).then(this.$router.push({name: 'error'}))
                    });
            },
            //〇×ボタン押下時のlist書き換え用メソッド
            clickCheck:function (event,itemId,indexCOunt,cookingCheckHeaderId) {

                //ボタン押下時のクリック制御
                var buttonCheckList = this.list[indexCOunt];

                //すべて〇チェックの場合は制御なし
                if(buttonCheckList.allCheckFlg === "1"){
                    return;
                }

                if(buttonCheckList[itemId] != 2){
                    var inCount = Number(buttonCheckList[itemId]);
                    buttonCheckList[itemId] = inCount + 1;
                    buttonCheckList = this.makeData(buttonCheckList,cookingCheckHeaderId,itemId);
                }
                else{
                    buttonCheckList[itemId] = "";
                    buttonCheckList = this.makeData(buttonCheckList,cookingCheckHeaderId,itemId);
                }

                this.list.splice(indexCOunt,1,buttonCheckList);
            },
            //すべて〇チェック時
            clickAllCheck:function (indexCount) {
                let list = this.list[indexCount];
                let headerList = this.inputTypeFilter(list, 4);
                this.allCheck(indexCount, headerList);

            },
            //すべて〇チェック処理
            allCheck:function (indexCount, headerList){
                let headerId = "";
                if (this.list[indexCount].allCheckFlg === "0") {
                    headerId = "1";
                    this.list[indexCount].allCheckFlg = "1";
                } else {
                    this.list[indexCount].allCheckFlg = "0";
                }

                let buttonList = this.list[indexCount];
                headerList.forEach(item => {
                    if(buttonList['htsi_'+item.cookingCheckHeaderId] === 1) {
                        buttonList['hd_' + item.cookingCheckHeaderId] = headerId;
                        let makeButtonList = this.makeData(buttonList, item.cookingCheckHeaderId, 'hd_' + item.cookingCheckHeaderId);
                        this.list.splice(indexCount, 1, makeButtonList);
                    }
                });
            },
            //調理名のプルダウン押下時の入力制御設定
            async tyoriInput (event,indexCOunt) {

                var textValue = event.target.value;
                var commnetList = this.list[indexCOunt];

                if(Object.keys(textValue).length){
                    this.isLoading = true;

                    //重要管理項目チェック詳細取得API呼び出し
                    var cookingid = textValue;

                    await this.getCookingName();
                    this.isLoading = false;
                    let cooking = this.cookingCheckMenuList.cookingList.filter(cooking => {
                        return cooking.cookingId == cookingid;
                    });

                    this.cooking.cookingId = cooking[0].cookingId;
                    this.cooking.existHistory = '';
                    this.cooking.checkedList = cooking[0].inputList;

                    commnetList['cookingId'] = cookingid;
                    // 当日調理フラグ初期化
                    commnetList['todayInputFlg'] = '';
                    // コメント初期化
                    commnetList['comment'] = '';
                    // センサー初期化
                    commnetList['cencer'] = '';

                    //dataへの埋め込みデータ成形
                    for(var i=0; i < this.cooking.checkedList.length ; i++){

                        for(var diteleCount= 0 ; diteleCount < commnetList.histryData.length ; diteleCount++ ) {

                            if (this.cooking.checkedList[i].cookingCheckHeaderId == commnetList.histryData[diteleCount].cookingCheckHeaderId) {
                                if (this.cooking.checkedList[i].inputFlg) {

                                    commnetList["htsi_" + this.cooking.checkedList[i].cookingCheckHeaderId] = this.cooking.checkedList[i].inputFlg;
                                    commnetList["hd_" + this.cooking.checkedList[i].cookingCheckHeaderId] = "";
                                    var histryDataOnList = commnetList.histryData[diteleCount];
                                    histryDataOnList['dayStatus'] = null;
                                    histryDataOnList['defStatus'] = 1;
                                    histryDataOnList['result_value'] = '';
                                    histryDataOnList['cookingcheckitemid'] = this.cooking.checkedList[i].cookingCheckItemId;
                                    //commnetList.histryData.splice(diteleCount, 1, histryDataOnList);
                                }
                                else{
                                    commnetList["htsi_" + this.cooking.checkedList[i].cookingCheckHeaderId] = "";
                                    commnetList["hd_" + this.cooking.checkedList[i].cookingCheckHeaderId] = "";
                                    var histryDataOnList2 = commnetList.histryData[diteleCount];
                                    histryDataOnList2['dayStatus'] = null;
                                    histryDataOnList2['defStatus'] = 3;
                                    histryDataOnList2['result_value'] = '';
                                    histryDataOnList2['cookingcheckitemid'] = this.cooking.checkedList[i].cookingCheckItemId;
                                    //commnetList.histryData.splice(diteleCount, 1, histryDataOnList2);
                                }
                            }
                        }
                    }

                    //すべて〇チェックボタン表示
                    commnetList['allCheckFlg'] = this.updateAllCheckFlg(this.list[indexCOunt]);

                    //履歴の有無判定
                    commnetList["historyFlg"] = '';
                }
                else{
                    for( var p=0 ; p < commnetList.histryData.length ; p++){
                        commnetList.histryData[p]['status']= null;
                        commnetList.histryData[p]['result_value']=null;
                        commnetList.histryData[p]['dayStatus']=null;
                        commnetList.histryData[p]["defStatus"]=null;
                    }
                    commnetList["cookingNameNo"] = null;
                    commnetList["tyori"] = "";
                    commnetList["cookingName"] = "";
                    commnetList["cookingId"] = "";
                    commnetList["cookingNo"] = null;
                    commnetList["comment"] = "";
                    commnetList["todayInputFlg"] = "";
                    commnetList["cencer"] = "";
                    commnetList["historyFlg"] = "";
                    //すべて〇チェックボタン非表示
                    commnetList['allCheckFlg'] = "";

                    for( var k=0 ; k < this.cookingCheckMenuList.cookingHeaderList.length ; k++) {
                        if (this.cookingCheckMenuList.cookingHeaderList[k].displayFlg) {
                            commnetList["hd_" + this.cookingCheckMenuList.cookingHeaderList[k].cookingCheckHeaderId] = "";
                            commnetList["htsi_" + this.cookingCheckMenuList.cookingHeaderList[k].cookingCheckHeaderId] = "";
                        }
                    }
                }
                //配列に反映
                this.list.splice(indexCOunt,1,commnetList);
            },
            //当日調理無のボタン押下時の入力操作
            todayCheckInput:function (indexCOunt,hederId) {
                var commnetList = this.list[indexCOunt];

                // 当日チェックがOFFの場合
                if(commnetList["todayInputFlg"] != 1){
                    commnetList["todayInputFlg"] =  1;

                    // 内部データの書き換えの繰り返し
                    for(var onCoint= 0 ; onCoint < commnetList.histryData.length ; onCoint++ ){

                        var histryDataOnList = commnetList.histryData[onCoint];
                        // 当日チェック チェック内容反映
                        if(commnetList.histryData[onCoint].cookingCheckHeaderId == hederId){
                            histryDataOnList['result_value'] = 1;
                        }

                        // ヘッダーNO 2-7は当日フラグ対象として除去
                        if([2,3,4,5,6,7].includes(commnetList.histryData[onCoint].cookingCheckHeaderNo)){
                            // 入力表示用フラグ初期化
                            commnetList["hd_" + commnetList.histryData[onCoint].cookingCheckHeaderId] = '';
                            commnetList["htsi_" + commnetList.histryData[onCoint].cookingCheckHeaderId] = '';

                            histryDataOnList['dayStatus'] = 2;
                            histryDataOnList['result_value'] = '';
                        }
                    }
                }
                // 当日チェックがONの場合
                else{
                    commnetList["todayInputFlg"] = "";
                    // 入力制御用としてAPIデータを繰り返し

                    for(var i=0; i < this.cooking.checkedList.length ; i++) {
                        // 内部データの書き換えの繰り返し
                        for (var dwCount = 0; dwCount < commnetList.histryData.length; dwCount++) {

                            var histryDataOffList = commnetList.histryData[dwCount];

                            // 当日チェック チェック内容反映
                            if(commnetList.histryData[dwCount].cookingCheckHeaderId == hederId){
                                histryDataOffList['result_value'] = 0;
                            }

                            //  ヘッダーNO 2-7に初期値を設定
                            if (this.cooking.checkedList[i].cookingCheckHeaderId == commnetList.histryData[dwCount].cookingCheckHeaderId) {
                                // ヘッダーNO 2-7は当日フラグ対象として初期化
                                if ([2, 3, 4, 5, 6, 7].includes(commnetList.histryData[dwCount].cookingCheckHeaderNo)) {
                                    // ヘッダーのInputフラグ判定
                                    if (this.cooking.checkedList[i].inputFlg) {
                                        commnetList["htsi_" + this.cooking.checkedList[i].cookingCheckHeaderId] = this.cooking.checkedList[i].inputFlg;
                                        histryDataOffList['dayStatus'] = null;
                                        histryDataOffList['result_value'] = '';
                                    } else {
                                        commnetList["htsi_" + this.cooking.checkedList[i].cookingCheckHeaderId] = "";
                                        histryDataOffList['dayStatus'] = null;
                                        histryDataOffList['result_value'] = '';
                                    }
                                }
                            }
                        }
                    }

                }

                //配列に反映
                this.list.splice(indexCOunt,1,commnetList)
                let beforeAllCheckFlg =this.list[indexCOunt].allCheckFlg;
                let allCheckFlg = this.updateAllCheckFlg(this.list[indexCOunt]);

                this.list[indexCOunt].allCheckFlg = allCheckFlg;

                //すべて〇がチェックされている場合、一旦戻して再チェック
                if(beforeAllCheckFlg === '1' && allCheckFlg === '0'){
                    this.clickAllCheck(indexCOunt);
                }
            },
            //すべて〇チェックボックスの表示制御
            updateAllCheckFlg:function(list){

                //入力タイプが〇×かつ有効なヘッダーを取得する
                let headerList = this.inputTypeFilter(list, 4);

                //〇×のヘッダーがなければすべて〇を非表示
                if(headerList.length < 1){
                    return "";
                }

                //入力可能な項目がなければ、すべて〇を非活性にする
                let result = '2';
                headerList.forEach(item => {
                    if(list['htsi_'+item.cookingCheckHeaderId] === 1) {
                        //入力可能な項目があれば、すべて〇を活性にする
                        result = '0';
                    }
                });

                return result;
            },
            makeData(buttonCheckList,cookingCheckHeaderId,itemId){

                for(var Count= 0 ; Count < buttonCheckList.histryData.length ; Count++ ){
                    if(buttonCheckList.histryData[Count].cookingCheckHeaderId == cookingCheckHeaderId){
                        var histryDataOnList = buttonCheckList.histryData[Count];

                        if(buttonCheckList[itemId] == 1){
                            histryDataOnList['result_value'] = 1;
                            buttonCheckList.histryData.splice(Count,1,histryDataOnList);
                        }
                        else if(buttonCheckList[itemId] == 2){
                            histryDataOnList['result_value'] = 0;
                            buttonCheckList.histryData.splice(Count,1,histryDataOnList);
                        }
                        else{
                            histryDataOnList['result_value'] = '';
                            buttonCheckList.histryData.splice(Count,1,histryDataOnList);
                        }
                    }
                }
                return buttonCheckList;
            },
            chengeClore:function (histryData,indexCount) {

                var ListLength = this.list.length;
                // 初期表示時(Listは1行の為デフォルトスタイルを返却)
                if(ListLength == 1){
                    return this.cookingColorInput;
                }
                else{
                    var defStatus = histryData[indexCount].defStatus;
                    var dayStatus = histryData[indexCount].dayStatus;
                    if(dayStatus == 2){
                        return this.cookingColorNoInput;
                    }
                    else if(defStatus == 3){
                        return this.cookingColorDisabled;
                    }
                    else{
                        return this.cookingColorInput;
                    }
                }
            },
            onCloseTimePicker: function (v, indexCount, index) {
                const replacedTime = this.replaceTime(v)
                if (replacedTime) {
                    this.filterItems[indexCount].histryData[index].result_value = replacedTime
                }
            },
            replaceTime: function (v) {
                if (v === 'HH:mm') {
                    return
                }
                return v.replace(/HH|mm/, '00')
            },
            //すべて〇の表示位置調整
            allOkHeader: function () {
                var headerHeight = this.$refs.tbody.clientHeight
                this.headerStyle.height = headerHeight + 'px'

                var boxHeight = document.getElementById('tdHeight').childNodes[0].clientHeight
                this.boxStyle.height = boxHeight + 'px'
            },
            inputTypeFilter: function (indexList, inputType) {

                //入力タイプが〇×のヘッダーを取得する
                let headerList = this.cookingCheckMenuList.cookingHeaderList.filter(item => item.inputType === inputType && item.displayFlg);

                //当日調理無がONの場合はチェック対象外を弾く
                if (indexList.todayInputFlg === 1) {
                    const todayNonCheckNo = [2, 3, 4, 5, 6, 7];
                    headerList = headerList.filter(item => { return !(todayNonCheckNo.includes(item.cookingCheckHeaderNo)) });
                }

                return headerList;
            },

            dateFormat(){
                let nowDate = new Date();
                let year = nowDate.getFullYear();
                let month = ('0' + (nowDate.getMonth()+1)).slice(-2);
                let day = ('0' + nowDate.getDate()).slice(-2);
                let hours = ('0' + nowDate.getHours()).slice(-2);
                let minutes = ('0' + nowDate.getMinutes()).slice(-2);
                let seconds = ('0' + nowDate.getSeconds()).slice(-2);

                let format_str = 'YYYYMMDDhhmmss';
                format_str = format_str.replace(/YYYY/g,year);
                format_str = format_str.replace(/MM/g,month);
                format_str = format_str.replace(/DD/g,day);
                format_str = format_str.replace(/hh/g,hours);
                format_str = format_str.replace(/mm/g,minutes);
                format_str = format_str.replace(/ss/g,seconds);
                return format_str;
            }
        }
    }
</script>